import FilterForm from '../../../components/forms/FilterForm';
import { CanAccess, CrudFilters, HttpError } from '@refinedev/core';
import { EditButton, TagField, TextField, useTable } from '@refinedev/antd';
import { EyeOutlined } from '@ant-design/icons';
import { Form, Input, Select, Space, Table } from 'antd';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { TOfferCampaign } from 'interfaces/offers';
import { tagColorByStatus } from '../../../utils/statusColorMapping';

interface IFilter {
  name: string;
  status: string;
}

export const OfferCampaignList = () => {
  const { tableProps, searchFormProps } = useTable<
    TOfferCampaign,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { name, status } = params;

      filters.push(
        {
          field: 'filter[name]',
          operator: 'eq',
          value: name
        },
        {
          field: 'filter[status]',
          operator: 'eq',
          value: status
        }
      );

      return filters;
    }
  });

  return (
    <ListLayout title="Campanhas">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="name">
          <Input placeholder="Nome da campanha" className="lg:min-w-[300px]" />
        </Form.Item>

        <Form.Item name="status">
          <Select placeholder="Status">
            <Select.Option key="disabled">Desabilitado</Select.Option>
            <Select.Option key="expired">Expirado</Select.Option>
            <Select.Option key="active">Ativo</Select.Option>
          </Select>
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="status"
          key="status"
          title="Status"
          render={value => (
            <TagField
              color={tagColorByStatus(value)}
              value={
                value === 'disabled'
                  ? 'Desabilitado'
                  : value === 'expired'
                  ? 'Expirado'
                  : value === 'active'
                  ? 'Ativo'
                  : '-'
              }
            />
          )}
        />
        <Table.Column<TOfferCampaign>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={80}
          render={(_, record) => {
            return (
              <Space>
                <CanAccess resource="offer_campaigns" action="edit">
                  <EditButton
                    hideText
                    size="small"
                    icon={<EyeOutlined />}
                    recordItemId={record.id}
                  />
                </CanAccess>
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
